import React, { Component, ReactNode } from "react";
import ChatPopUp from "components/ChatPopUp";
import CookiePopUp from "components/CookiePopUp";
import Header from "components/Header";
import Footer from "components/Footer";
import ContentPageProvider from "components/content/ContentPageProvider";
import "./index.scss";
import { RouteComponentProps, withRouter } from "react-router";
import SookHelmet from "../../components/sookHelmet";
import { ContentPage } from "services/entities/content";
import { Space } from "services/entities/spaces";
import DelayComponentRender from "components/DelayComponentRender";

interface DefaultLayoutState {
  menuOpen: boolean;
}

export interface DefaultLayoutProps extends RouteComponentProps {
  id?: string;
  children: any;
  header?: ReactNode;
  footer?: ReactNode;
  topChildren?: ReactNode;
  className?: string;
  pageData?: ContentPage | Space | null;
}

class DefaultLayout extends Component<DefaultLayoutProps, DefaultLayoutState> {
  state = {
    menuOpen: false,
  };

  onHeaderToggled = (open: boolean) => {
    this.setState({ menuOpen: open });
  };

  componentDidMount() {}
  render() {
    let className = "default-layout";
    if (this.props.className) {
      className += " " + this.props.className;
    }
    if (this.state.menuOpen) {
      className += " menu-open";
    }

    return (
      <ContentPageProvider url={this.props.location.pathname}>
        <CookiePopUp />
        <div className={className} id={this.props.id}>
          <SookHelmet value={this.props.pageData} />
          {this.props.header || (
            <Header onToggled={this.onHeaderToggled} variant="content-mw" />
          )}
          {this.props.topChildren}
          <div id="body">{this.props.children}</div>
          {this.props.footer || (
            <DelayComponentRender delayTime={2000}>
              <Footer />
            </DelayComponentRender>
          )}
          <ChatPopUp />
        </div>
      </ContentPageProvider>
    );
  }
}

export default withRouter(DefaultLayout);
